import React, { useState, useEffect } from "react";
import "./FollowupTreatment.css";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { ncdAPI } from "../../../services/ncd.api";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNCD } from "../hooks/useNCD";
import PrescriptionView from "./PrescriptionView";

export const FollowupTreatment = ({
  hideSection,
  individualId,
  htnScreenId,
  diabScreenId,
  setShowNcdFollowup,
}) => {
  const [viewMode] = useState("ADD");
  const [openAccordionIndex, setOpenAccordionIndex] = useState(0);
  const toggleAccordion = (index) => {
    setOpenAccordionIndex(openAccordionIndex === index ? null : index);
  };
  const { loading, setLoading } = useNCD();
  const [prescriptionData, setPrescriptionData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTreatments, setSelectedTreatments] = useState({
    hypertension: false,
    diabetes: false
  });

  const isVitalsEnabled = selectedTreatments.hypertension || selectedTreatments.diabetes;

  const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);

  const [prescriptionAvailable, setPrescriptionAvailable] = useState(null);
  const [errors, setErrors] = useState({});

  const handlePrint = () => {
    const printContent = document.querySelector('.print-content');
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Prescription</title>');
    printWindow.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">');
    printWindow.document.write('</head><body>');
    printWindow.document.write(printContent.innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  const [uploadedFileName, setUploadedFileName] = useState("");

  const [uploadedFile, setUploadedFile] = useState(null);

  //    -------------------------------------------------------------------------------------

  const [medicationRows, setMedicationRows] = useState([
    {
      id: 1,
      condition: "",
      medicine: "",
      frequency: "",
      duration: "",
      quantity: "",
    },
  ]);

  const conditionOptions = [
    { value: "Hypertension", label: "Hypertension" },
    { value: "Diabetes", label: "Diabetes" },
  ];

  const filteredConditionOptions = conditionOptions.filter(option => {
    if (option.value === "Hypertension") return selectedTreatments.hypertension;
    if (option.value === "Diabetes") return selectedTreatments.diabetes;
    return false;
  });

  // Static medicine data
  const initialMedicineOptions = {
    Hypertension: [],
    Diabetes: [],
  };

  const [medicineOptions, setMedicineOptions] = useState(
    initialMedicineOptions
  );

  function getCurrentDateFormatted() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = today.getFullYear(); // Full 4-digit year
    return `${day}-${month}-${year}`;
  }

  const [followupform, setFollowupForm] = useState({
    programId: 1,
    examinationId: htnScreenId,
    examination: {
      isVitalsEdited: true,
      exam: {
        assessDate: "",
        sys: "",
        diast: "",
        heartRate: "",
      },
    },
    diagnosis: {
      assessmentDate: "",
      selectedDiagnosis: "CONFIRMED_STAGE_1",
      prescriptionAvailable: null,
    },
    treatment: {
      treat: {
        facility: "SUBCENTER",
        treatDate: getCurrentDateFormatted(),
        reviewDate: getCurrentDateFormatted(),
        sys: "",
        diast: "",
        heartRate: "",
        selMeds: [],
        removeCurrMedication: false,
        treatDateWithTimeStamp: null,
        dgns: {
          assessDate: getCurrentDateFormatted(),
          diagRresult: "CONFIRMED_STAGE_1",
        },
        isTreatmentOnProtocol: false,
        diagnosedHypertensionStage: 1,
        docfolUp: {
          followUpDueDate: getCurrentDateFormatted(),
          followUpDuration: "28;0;0",
          followUpReason: "Review",
          remarks: null,
        },
      },
      treatmentAttestation: {
        declaration: false,
        doctorConsulted: null,
        referenceNumber: null,
        doctorFacility: null,
      },
      treatmentFiles: {
        teleconFiles: null,
      },
    },
  });

  const [followupformDb, setFollowupFormDb] = useState({
    programId: 1,
    examinationId: diabScreenId,
    examination: {
      isVitalsEdited: true,
      exam: {
        assessDate: getCurrentDateFormatted(),
        rbs: "",
      },
    },
    diagnosis: {
      date: getCurrentDateFormatted(),
      selectedDiagnosis: "CONFIRMED",
      prescriptionAvailable: null,
    },
    treatment: {
      treat: {
        reviewIn: {
          isProtocolOverriden: true,
          facility: "SUBCENTER",
          treatDate: getCurrentDateFormatted(),
          reviewDate: getCurrentDateFormatted(),
          rbs: "",
          selMeds: [],
          removeCurrMedication: false,
          conDn: true,
          treatDateWithTimeStamp: null,
          diabetesDiagnosisModel: {
            date: getCurrentDateFormatted(),
            selectedDiagnosis: "CONFIRMED",
          },
          docfolUp: {
            followUpDueDate: getCurrentDateFormatted(),
            followUpDuration: "28;0;0",
            followUpReason: "Review",
            remarks: null,
          },
        },
      },
      treatmentAttestation: {
        declaration: true,
        doctorConsulted: null,
        referenceNumber: null,
        doctorFacility: null,
      },
      treatmentFiles: {
        teleconFiles: null,
      },
    },
  });


  useEffect(() => {
    const fetchPrescription = async () => {
      if (individualId) {
        try {
          const response = await ncdAPI.getPrescription(individualId);
          if (response.success) {
            setPrescriptionData(response.data);
          }
        } catch (error) {
          console.error("Error in fetching prescription:", error);
        }
      }
    };
    fetchPrescription();
  }, [individualId]);

  const handlefollowup = (e, fieldPaths) => {
    const { value, type, files, name } = e.target;

    // Ensure fieldPaths is always treated as an array
    const paths = Array.isArray(fieldPaths) ? fieldPaths : [fieldPaths];

    setFollowupForm((prevState) => {
      let newState = { ...prevState };

      paths.forEach((fieldPath) => {
        const path = fieldPath.split("."); // Ensure fieldPath is a string

        let current = newState;

        // Check if the field name is "assessmentDate" and handle date conversion
        if (name === "assessmentDate") {
          const selectedDate = new Date(value);
          const formattedDate = selectedDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .replace(/\//g, "-"); // Convert format to dd-mm-yyyy

          // Update date field in state
          for (let i = 0; i < path.length - 1; i++) {
            if (!current[path[i]]) current[path[i]] = {};
            current = current[path[i]];
          }
          current[path[path.length - 1]] = formattedDate;
          return; // Exit early since we've handled the date conversion
        }

        // Handle radio buttons (convert "true"/"false" to boolean)
        let finalValue = type === "radio" ? value === "true" : value;

        // Handle file inputs
        if (type === "file") {
          finalValue = files;
        }

        // Handling dynamic arrays like `selMeds[0]`
        if (path.length > 2 && path[2].startsWith("selMeds[")) {
          const index = parseInt(
            path[2].replace("selMeds[", "").replace("]", "")
          );
          const field = path[3]; // Extract field name (e.g., 'conditn', 'name')

          if (!current.treatment.treat.selMeds[index]) {
            current.treatment.treat.selMeds[index] = {};
          }
          current.treatment.treat.selMeds[index][field] = finalValue;
        } else {
          // Handle normal field updates
          for (let i = 0; i < path.length - 1; i++) {
            if (!current[path[i]]) current[path[i]] = {};
            current = current[path[i]];
          }
          current[path[path.length - 1]] = finalValue;
        }
      });

      return newState;
    });
  };

  const handlefollowupDb = (e, fieldPaths) => {
    const { value, type, files, name } = e.target;

    // Ensure fieldPaths is always treated as an array
    const paths = Array.isArray(fieldPaths) ? fieldPaths : [fieldPaths];

    setFollowupFormDb((prevState) => {
      let newState = { ...prevState };

      paths.forEach((fieldPath) => {
        const path = fieldPath.split("."); // Split the field path into parts
        let current = newState;

        // Check if the field name is "assessmentDate" and handle date conversion
        if (name === "assessmentDate") {
          const selectedDate = new Date(value);
          const formattedDate = selectedDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .replace(/\//g, "-"); // Convert format to dd-mm-yyyy

          // Update the date field in the state
          for (let i = 0; i < path.length - 1; i++) {
            if (!current[path[i]]) current[path[i]] = {};
            current = current[path[i]];
          }
          current[path[path.length - 1]] = formattedDate;
          return; // Exit early since we've handled the date conversion
        }

        // Handle radio buttons (convert "true"/"false" to boolean)

        let finalValue;

        if (type === "radio") {
          finalValue = value === "true";
        }
        else if (type === "checkbox") {
          finalValue = e.target.checked;   // ✅ THIS FIXES "on" ISSUE
        }
        else {
          finalValue = value;
        }

        // Handle file inputs
        if (type === "file") {
          finalValue = files;
        }

        // Handling dynamic arrays like `selMeds[0]`

        if (path.length > 3 && path[3].startsWith("selMeds[")) {
          const index = parseInt(
            path[3].replace("selMeds[", "").replace("]", "")
          );
          const field = path[4]; // Extract field name (e.g., 'conditn', 'name')

          // Ensure `selMeds` exists and is an array
          if (!current.treatment.treat.reviewIn.selMeds) {
            current.treatment.treat.reviewIn.selMeds = [];
          }

          // Update the array at the correct index
          if (!current.treatment.treat.reviewIn.selMeds[index]) {
            current.treatment.treat.reviewIn.selMeds[index] = {}; // Initialize if undefined
          }

          current.treatment.treat.reviewIn.selMeds[index][field] = finalValue;
        } else {
          // Handle normal field updates

          for (let i = 0; i < path.length - 1; i++) {
            if (!current[path[i]]) current[path[i]] = {};
            current = current[path[i]];
          }
          current[path[path.length - 1]] = finalValue;
        }
      });

      return newState;
    });
  };

  const handleConditionChange = async (id, condition) => {
    let medicines = [];

    setLoading(true);

    if (condition === "Hypertension") {
      medicines = await ncdAPI.getFollowupMedicines(500);
    }

    if (condition === "Diabetes") {
      medicines = await ncdAPI.getFollowupMedicines(600);
    }

    // Transforming the medicines array
    const transformedMedicines = medicines?.data.medicineRecords.flatMap((medicine) =>
      medicine.doses.map((dose) => ({
        name: `${medicine.name} - ${dose}`,
        dose: dose,
        diseaseId: medicine.diseaseId,
        stateId: medicine.stateId,
      }))
    );

    // Assuming the medicines returned from the API have the same structure (with doses)
    setMedicineOptions((prevState) => ({
      ...prevState,
      [condition]: transformedMedicines.map((medicine) => medicine.name), // Store medicine names for the dropdown
    }));

    setMedicationRows((rows) =>
      rows.map((row) =>
        row.id === id ? { ...row, condition, medicine: "" } : row
      )
    );

    setLoading(false);
  };

  const handleMedicineChange = (id, medicine) => {
    setMedicationRows((rows) =>
      rows.map((row) => (row.id === id ? { ...row, medicine } : row))
    );
  };

  const calculateQuantity = (frequency, duration) => {
    const freqMap = { "Once a day": 1, "Twice a day": 2, "Thrice a day": 3, "Four times a day": 4 };
    const freqCount = freqMap[frequency] || 0;
    return freqCount * (parseInt(duration) || 0);
  };

  const handleAddRow = () => {
    setMedicationRows([
      ...medicationRows,
      { id: Date.now(), condition: "", medicine: "", frequency: "", duration: "", quantity: "" },
    ]);
  };

  const handleDeleteRow = (id) => {
    setMedicationRows(medicationRows.filter((row) => row.id !== id));
  };

  // -----------------------------------------------------------------------------------------

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExtensions = ["pdf", "jpg", "jpeg", "png"];
    const maxSize = 100 * 1024; // 100 KB
    const fileExtension = file.name.split(".").pop().toLowerCase();

    // 🔴 Extension validation
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error("Only PDF, JPG, JPEG, PNG files are allowed");
      e.target.value = "";
      return;
    }

    // 🔴 Size validation
    if (file.size > maxSize) {
      toast.error("File size must be less than 100 KB");
      e.target.value = "";
      return;
    }

    try {
      setLoading(true);

      const reader = new FileReader();

      reader.onload = async () => {
        const base64String = reader.result.split(",")[1];

        const payload = {
          fileContent: base64String,
          fileName: file.name,
        };

        console.log("Uploading file payload:", payload);

        // ✅ CALL YOUR API HERE
        const response = await ncdAPI.uploadTeleconsultationFile(
          individualId,
          payload
        );

        if (response?.success) {
          toast.success("File uploaded successfully!");
          setUploadedFile({
            fileName: file.name,
            uploadId: response.data.uploadId,
          });

          setUploadedFileName(file.name);

        } else {
          toast.error("File upload failed");
        }

        setLoading(false);
      };

      reader.readAsDataURL(file);
    } catch (error) {
      setLoading(false);
      toast.error("Something went wrong while uploading file");
    }
  };

  const teleConsultationSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    let firstErrorField = null;

    if (!selectedTreatments.hypertension && !selectedTreatments.diabetes) {
      newErrors.treatment = "Please select at least one treatment";
      if (!firstErrorField) firstErrorField = "treatment";
    }

    if (prescriptionAvailable === null) {
      newErrors.prescription = "This field is required";
      if (!firstErrorField) firstErrorField = "prescription";
    }

    if (selectedTreatments.hypertension && prescriptionAvailable === true) {
      if (!followupform.examination.exam.sys) {
        newErrors.sys = "Required for Hypertension with prescription";
        if (!firstErrorField) firstErrorField = "sys";
      }
      if (!followupform.examination.exam.diast) {
        newErrors.diast = "Required for Hypertension with prescription";
        if (!firstErrorField) firstErrorField = "diast";
      }
    }

    if (selectedTreatments.diabetes) {
      if (!followupformDb.examination.exam.rbs) {
        newErrors.rbs = "Required for Diabetes";
        if (!firstErrorField) firstErrorField = "rbs";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTimeout(() => {
        const element = document.querySelector(`[name="${firstErrorField}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus();
        }
      }, 100);
      return;
    }

    setErrors({});

    try {
      setLoading(true);

      // Remove empty medication rows before submitting

      // Remove null and empty medication rows before submitting
      const filteredFollowupForm = {
        ...followupform,
        treatment: {
          ...followupform.treatment,
          treat: {
            ...followupform.treatment.treat,
            selMeds:
              followupform?.treatment?.treat?.selMeds?.filter(
                (med) => med && med.name && med.freq && med.dur && med.quan
              ) || [],
          },
        },
      };

      const filteredFollowupFormDb = {
        ...followupformDb,
        treatment: {
          ...followupformDb?.treatment,
          treat: {
            ...followupformDb?.treatment?.treat,
            reviewIn: {
              ...followupformDb?.treatment?.treat?.reviewIn,
              selMeds:
                followupformDb?.treatment?.treat?.reviewIn?.selMeds?.filter(
                  (med) => med && med.name && med.freq && med.dur && med.quan
                ) || [],
            },
          },
        },
      };


      let filePayload = {};

      if (uploadedFile) {
        filePayload = {
          teleconFiles: [
            {
              fileName: uploadedFile.fileName,
              uploadId: uploadedFile.uploadId,
            },
          ],
        };
      }

      const finalFollowupForm = {
        ...filteredFollowupForm,
        treatment: {
          ...filteredFollowupForm.treatment,
          treatmentFiles: filePayload,
        },
      };

      const finalFollowupFormDB = {
        ...filteredFollowupFormDb,
        treatment: {
          ...filteredFollowupFormDb.treatment,
          treatmentFiles: filePayload,
        },
      };

      const response = await ncdAPI.submitTeleconsultation(
        individualId,
        finalFollowupForm
      );

      const responsedb = await ncdAPI.submitTeleconsultationDB(
        individualId,
        finalFollowupFormDB
      );

      if (response?.data?.screeningId || responsedb?.data?.screeningId) {
        toast.success(`Treatment saved successfully!`);
        setLoading(false);
      } else {
        toast.error(response.message || "Failed to save data", {
          className: "custom-toast-error",
        });
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong", {
        className: "custom-toast-error",
      });
      setLoading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  const accordionData = [
    {
      title: "Diagnosis History",
      content: (
        <>
          <div className="row">
            {/* Date Input */}
            <div className="col-md-3">
              <div>
                <span className="exam-label">Date</span>
                {viewMode === "ADD" ? (
                  <input
                    type="date"
                    name="assessmentDate"
                    className="exam-textarea"
                    onChange={(e) =>
                      handlefollowup(e, [
                        "examination.exam.assessDate",
                        "diagnosis.assessmentDate",
                      ])
                    }
                    max={today}
                  />
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>

            {/* Currently on Treatment? (Inline Checkboxes) */}
            <div className="col-md-3">
              <div className="exam-check">
                <span className="exam-label">Currently on Treatment?<span className="ng-star"> *</span></span>
                {viewMode === "ADD" ? (
                  <>
                    <div className="div-check">
                      <label>
                        <input
                          type="checkbox"
                          name="treatment"
                          className="me-1"
                          checked={selectedTreatments.hypertension}
                          onChange={(e) => {
                            setSelectedTreatments({ ...selectedTreatments, hypertension: e.target.checked });
                            if (errors.treatment) setErrors({ ...errors, treatment: undefined });
                          }}
                        />{" "}
                        Hypertension
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="treatment"
                          className="me-1"
                          checked={selectedTreatments.diabetes}
                          onChange={(e) => {
                            setSelectedTreatments({ ...selectedTreatments, diabetes: e.target.checked });
                            if (errors.treatment) setErrors({ ...errors, treatment: undefined });
                          }}
                        />{" "}
                        Diabetes
                      </label>
                    </div>
                    {errors.treatment && <small style={{ color: 'red' }}>{errors.treatment}</small>}
                  </>
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div>
                <span className="exam-label">
                  Prescription or state-issued health card available with
                  patient during visit?<span className="ng-star"> *</span>
                </span>
                {viewMode === "ADD" ? (
                  <>
                    <div className="exam-radio">
                      <label>
                        <input
                          type="radio"
                          name="prescription"
                          value="true"
                          className="me-1"
                          onChange={(e) => {
                            handlefollowup(e, "diagnosis.prescriptionAvailable");
                            setPrescriptionAvailable(true);
                            if (errors.prescription) setErrors({ ...errors, prescription: undefined });
                          }}
                        />{" "}
                        Yes
                      </label>
                      <label className="ms-3">
                        <input
                          type="radio"
                          name="prescription"
                          value="false"
                          className="me-1"
                          onChange={(e) => {
                            handlefollowup(e, "diagnosis.prescriptionAvailable");
                            setPrescriptionAvailable(false);
                            if (errors.prescription) setErrors({ ...errors, prescription: undefined });
                          }}
                        />{" "}
                        No
                      </label>
                    </div>
                    {errors.prescription && <small style={{ color: 'red' }}>{errors.prescription}</small>}
                  </>
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Vitals",
      content: (
        <>
          <div className={`row ${!isVitalsEnabled ? "blur-disabled" : ""}`}>
            <div className="img_icon">
              <img src={"/images/bp_readings.png"} alt="" />
              <p>BP Readings</p>
            </div>
            <div className="col-md-4">
              <div className="">
                <span className="exam-label">
                  Systolic blood pressure{" "} <span className="ng-star">* </span>
                  <span className="mmhg_css">
                    mmHg
                  </span>{" "}
                </span>
                {viewMode === "ADD" ? (
                  <>
                    <input
                      type="text"
                      name="sys"
                      className="exam-textarea"
                      onChange={(e) => {
                        handlefollowup(e, [
                          "examination.exam.sys",
                          "treatment.treat.sys",
                        ]);
                        if (errors.sys) setErrors({ ...errors, sys: undefined });
                      }}
                    />
                    {errors.sys && <small style={{ color: 'red', display: 'block' }}>{errors.sys}</small>}
                  </>
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <div className="">
                <span className="exam-label">
                  Diastolic blood pressure{" "} <span className="ng-star">*</span>
                  <span className="mmhg_css">
                    mmHg
                  </span>
                </span>
                {viewMode === "ADD" ? (
                  <>
                    <input
                      type="text"
                      name="diast"
                      className="exam-textarea"
                      onChange={(e) => {
                        handlefollowup(e, [
                          "examination.exam.diast",
                          "treatment.treat.diast",
                        ]);
                        if (errors.diast) setErrors({ ...errors, diast: undefined });
                      }}
                    />
                    {errors.diast && <small style={{ color: 'red', display: 'block' }}>{errors.diast}</small>}
                  </>
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
            <div className="col-md-3">
              <div className="">
                <span className="exam-label">
                  Heart Rate <span className="mmhg_css">BPM</span>
                </span>
                {viewMode === "ADD" ? (
                  <input
                    type="text"
                    name="heartRate"
                    className="exam-textarea"
                    onChange={(e) =>
                      handlefollowup(e, [
                        "examination.exam.heartRate",
                        "treatment.treat.heartRate",
                      ])
                    }
                  />
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
          </div>
          <div className={`row mt-4 ${!isVitalsEnabled ? "blur-disabled" : ""}`}>
            <div className="img_icon">
              <img src={"/images/el_diabetes.png"} alt="" />
              <p>Blood Sugar Levels</p>
            </div>
            <div className="col-md-3">
              <div className="">
                <span className="exam-label">
                  Random Blood Sugar <span className="ng-star">*</span>
                  <span className="mmhg_css">mg/dl</span>
                </span>
                {viewMode === "ADD" ? (
                  <>
                    <input
                      type="text"
                      name="rbs"
                      className="exam-textarea"
                      onChange={(e) => {
                        handlefollowupDb(e, [
                          "treatment.treat.reviewIn.rbs",
                          "examination.exam.rbs",
                        ]);
                        if (errors.rbs) setErrors({ ...errors, rbs: undefined });
                      }}
                    />
                    {errors.rbs && <small style={{ color: 'red', display: 'block' }}>{errors.rbs}</small>}
                  </>
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
          </div>
        </>
      ),
    },

    {
      title: "Medication",
      content: (
        <>
          <div className="table-responsive">
            <table className="exam-table custom-striped custom-table">
              <thead>
                <tr>
                  <th>Condition</th>
                  <th>Medicine</th>
                  <th>Frequency</th>
                  <th>Duration (in days)</th>
                  <th>Quantity</th>
                  <th>Special Instruction</th>
                  {viewMode === "ADD" && <th>Action</th>}
                </tr>
              </thead>

              <tbody>
                {medicationRows.map((row, rowIndex) => (
                  <tr key={row.id}>
                    <td>
                      <select
                        className="exam-dropdown"
                        name="conditn"
                        onChange={(e) => {
                          handleConditionChange(row.id, e.target.value);
                          if (e.target.value === "Hypertension") {
                            handlefollowup(
                              e,
                              `treatment.treat.selMeds[${rowIndex}].conditn`
                            );
                          }
                          if (e.target.value === "Diabetes") {
                            handlefollowupDb(
                              e,
                              `treatment.treat.reviewIn.selMeds[${rowIndex}].conditn`
                            );
                          }
                        }}
                      >
                        <option value="">Select Condition</option>
                        {filteredConditionOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        className="exam-dropdown"
                        name="name"
                        value={row.medicine}
                        onChange={(e) => {
                          handleMedicineChange(row.id, e.target.value);

                          if (row.condition === "Hypertension") {
                            handlefollowup(
                              e,
                              `treatment.treat.selMeds[${rowIndex}].name`
                            );
                          }
                          if (row.condition === "Diabetes") {
                            handlefollowupDb(
                              e,
                              `treatment.treat.reviewIn.selMeds[${rowIndex}].name`
                            );
                          }
                        }}
                      >
                        <option value="">Select Medicine</option>
                        {row.condition &&
                          medicineOptions[row.condition].map((medicine) => (
                            <option key={medicine} value={medicine}>
                              {medicine}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td>
                      {viewMode === "ADD" ? (
                        <select
                          name="freq"
                          className="exam-dropdown"
                          value={row.frequency}
                          onChange={(e) => {
                            const newFreq = e.target.value;
                            const newQty = calculateQuantity(newFreq, row.duration);
                            setMedicationRows(rows => rows.map(r => r.id === row.id ? { ...r, frequency: newFreq, quantity: newQty } : r));
                            if (row.condition === "Hypertension") {
                              handlefollowup(e, `treatment.treat.selMeds[${rowIndex}].freq`);
                              handlefollowup({ target: { value: newQty } }, `treatment.treat.selMeds[${rowIndex}].quan`);
                            }
                            if (row.condition === "Diabetes") {
                              handlefollowupDb(e, `treatment.treat.reviewIn.selMeds[${rowIndex}].freq`);
                              handlefollowupDb({ target: { value: newQty } }, `treatment.treat.reviewIn.selMeds[${rowIndex}].quan`);
                            }
                          }}
                        >
                          <option value="">Select</option>
                          <option value="Once a day">OD</option>
                          <option value="Twice a day">BD</option>
                          <option value="Thrice a day">TDS</option>
                          <option value="Four times a day">QDS</option>
                        </select>
                      ) : (
                        <span className="exam-value">--</span>
                      )}
                    </td>
                    <td>
                      {viewMode === "ADD" ? (
                        <input
                          type="number"
                          name="dur"
                          min="1"
                          value={row.duration}
                          className="exam-input form-control form-text-control"
                          onChange={(e) => {
                            const newDur = e.target.value;
                            const newQty = calculateQuantity(row.frequency, newDur);
                            setMedicationRows(rows => rows.map(r => r.id === row.id ? { ...r, duration: newDur, quantity: newQty } : r));
                            if (row.condition === "Hypertension") {
                              handlefollowup(e, `treatment.treat.selMeds[${rowIndex}].dur`);
                              handlefollowup({ target: { value: newQty } }, `treatment.treat.selMeds[${rowIndex}].quan`);
                            }
                            if (row.condition === "Diabetes") {
                              handlefollowupDb(e, `treatment.treat.reviewIn.selMeds[${rowIndex}].dur`);
                              handlefollowupDb({ target: { value: newQty } }, `treatment.treat.reviewIn.selMeds[${rowIndex}].quan`);
                            }
                          }}
                        />
                      ) : (
                        <span className="exam-value">--</span>
                      )}
                    </td>
                    <td>
                      {viewMode === "ADD" ? (
                        <input
                          type="number"
                          name="quan"
                          value={row.quantity}
                          readOnly
                          className="exam-input form-control form-text-control" style={{ background: '#f1f1f1' }}
                        />
                      ) : (
                        <span className="exam-value">--</span>
                      )}
                    </td>
                    <td>
                      {viewMode === "ADD" ? (
                        <select
                          name="spInst"
                          className="exam-dropdown"
                          onChange={(e) => {
                            if (row.condition === "Hypertension") {
                              handlefollowup(
                                e,
                                `treatment.treat.selMeds[${rowIndex}].spInst`
                              );
                            }
                            if (row.condition === "Diabetes") {
                              handlefollowupDb(
                                e,
                                `treatment.treat.reviewIn.selMeds[${rowIndex}].spInst`
                              );
                            }
                          }}
                        >
                          <option value="">Select</option>
                          <option value="After Food">After Food</option>
                          <option value="Before Food">Before Food</option>
                        </select>
                      ) : (
                        <span className="exam-value">--</span>
                      )}
                    </td>
                    {viewMode === "ADD" && (
                      <td>
                        <button
                          type="button"
                          className="delete-btn btn btn-danger"
                          onClick={() => handleDeleteRow(row.id)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {viewMode === "ADD" && (
              <button
                type="button"
                className="save-button mobile-btn mt-2"
                onClick={handleAddRow} 
              >
                Add
              </button>
            )}
          </div>
        </>
      ),
    },

    {
      title: "Attestation",
      content: (
        <>
          <div className="row">
            <div className="col-md-10">
              {viewMode === "ADD" && (
                <div>

                  <input
                    type="checkbox"
                    name="declaration"
                    checked={
                      followupform?.treatment?.treatmentAttestation?.declaration || false
                    }
                    className="mx-1"
                    onChange={(e) => {
                      const checked = e.target.checked;

                      // Update declaration properly as boolean
                      handlefollowup(
                        {
                          target: {
                            name: "declaration",
                            value: checked,
                            type: "checkbox",
                            checked: checked,
                          },
                        },
                        "treatment.treatmentAttestation.declaration"
                      );

                      // Clear fields if unchecked
                      if (!checked) {
                        setFollowupForm((prev) => ({
                          ...prev,
                          treatment: {
                            ...prev.treatment,
                            treatmentAttestation: {
                              ...prev.treatment.treatmentAttestation,
                              doctorConsulted: "",
                              referenceNumber: "",
                              doctorFacility: "",
                            },
                          },
                        }));
                      }
                    }}
                  />
                  I hereby declare and affirm to having used eSanjeevani/State
                  approved platform for teleconsultation.
                </div>
              )}
            </div>
          </div>
          <div className="row  mt-4">
            <div className="col-md-4">
              <div className="">
                <span className="exam-label">Doctor Consulted</span>
                {viewMode === "ADD" ? (
                  <input
                    type="text"
                    name="doctorConsulted"
                    className="exam-textarea"
                    disabled={!followupform?.treatment?.treatmentAttestation?.declaration}
                    onChange={(e) =>
                      handlefollowup(
                        e,
                        "treatment.treatmentAttestation.doctorConsulted"
                      )
                    }
                  />
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <div className="">
                <span
                  className="exam-label"
                  style={{ position: "relative", display: "inline-block" }}
                >
                  Doctor MRN
                  <Tooltip
                    title="Medical Registration Number"
                    arrow
                    placement="top"
                  >
                    <InfoOutlinedIcon
                      fontSize="small"
                      style={{
                        position: "absolute",
                        top: 0,
                        right: -24,
                        cursor: "pointer",
                        color: "#555",
                      }}
                    />
                  </Tooltip>
                </span>
                {viewMode === "ADD" ? (
                  <input
                    type="text"
                    name="referenceNumber"
                    className="exam-textarea"
                    disabled={!followupform?.treatment?.treatmentAttestation?.declaration}
                    onChange={(e) =>
                      handlefollowup(
                        e,
                        "treatment.treatmentAttestation.referenceNumber"
                      )
                    }
                  />
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <div className="">
                <span className="exam-label">Facility</span>
                {viewMode === "ADD" ? (
                  <select
                    className="exam-dropdown"
                    name="doctorFacility"
                    disabled={!followupform?.treatment?.treatmentAttestation?.declaration}
                    onChange={(e) =>
                      handlefollowup(
                        e,
                        "treatment.treatmentAttestation.doctorFacility"
                      )
                    }
                  >
                    <option value="">Select</option>
                    <option value="3400">DH</option>
                    <option value="3300">CHC</option>
                    <option value="3200">PHC</option>
                  </select>
                ) : (
                  <span className="exam-value">--</span>
                )}
              </div>
            </div>
          </div>
        </>
      ),
    },

    {
      title: "File Upload",
      content: (
        <>
          <div className="row">
            <div className="col-md-4">
              <span className="exam-label">Select Supporting document</span>
              <select className="exam-dropdown" name="supportingdocument">
                <option value="">Select</option>
                <option value="ePrescription">ePrescription</option>
                <option value="Prescription">Prescription</option>
                <option value="ODP Note">ODP Note</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="col-md-8">
              <label htmlFor="real-file" className="custom-upload">
                Choose File
              </label>
              <input type="file" id="real-file" onChange={handleFileUpload}></input>

              {uploadedFileName && (
                <div className="uploaded-file-name">
                  ✔ {uploadedFileName}
                </div>
              )}
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <section className="no-print">

        {loading && <Loader />}
        <div className="accordian_section cust-accordion">
          <div className="accordianScreenHeader">
            <h4 className="NCD-folloeup">
              <span>
                <img src={"/images/programs_logo/ncd.svg"} alt="" />
              </span>
              NCD Add Treatment/Follow-up
            </h4>
            <button type="button" className="save-button" onClick={() => setShowModal(true)}>
              Prescription
            </button>
            <div
              className="closeDive"
              onClick={() => {
                hideSection("Followptreatment");
                setShowNcdFollowup(false);
              }}
            >
              <img src={"/images/closing.svg"} alt="Close" />
            </div>
          </div>
          <form onSubmit={teleConsultationSubmit}>
            {accordionData.map((accordion, index) => (
              <div className="accordion" key={index}>
                <div
                  className="accordion-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <h6>{accordion.title}</h6>
                </div>
                <div className="accordion-content custom-pad">
                  {accordion.content}
                </div>
              </div>
            ))}

            <div className="button-container">
              <button type="submit" className="save-button ms-3">
                Save
              </button>
            </div>
          </form>
        </div>
      </section>
      {showModal && (
        <div className="modal-overlay no-print" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header no-print">
              <h5>Prescription</h5>
              <button className="btn btn-primary" onClick={handlePrint}>Print</button>
              <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
            </div>
            <div className="modal-body print-content" style={{ textAlign: "left" }}>
              {prescriptionData ? (
                <PrescriptionView data={prescriptionData} />
              ) : (
                <div>No prescription data available</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
